import React, { useEffect } from 'react'
import { Card, Result, Button, Space, Typography } from 'antd'
import { LogoutOutlined, LoginOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useMsal } from '@azure/msal-react'
import { clearUser, setLoggingOut } from './authSlice'

const { Text } = Typography

const Logout = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { instance } = useMsal()

  useEffect(() => {
    // Security Finding 8.6 - Defensive cleanup on logout landing page.
    // The actual MSAL logout has already happened at AAD (we landed here
    // via postLogoutRedirectUri). This effect is a safety net that ensures
    // session is fully terminated even if user reaches /logout directly
    // (e.g. via bookmark, back button, or session timeout).
    const cleanup = async () => {
      // 0. Turn off the global logging-out overlay - we have arrived at the
      //    final landing page after AAD logout completed.
      try {
        dispatch(setLoggingOut(false))
      } catch (_) {
        /* no-op */
      }

      // 1. Clear Redux auth state
      try {
        dispatch(clearUser())
      } catch (_) {
        /* no-op */
      }

      // 2. Wipe storage
      try {
        localStorage.clear()
        sessionStorage.clear()
      } catch (_) {
        /* no-op */
      }

      // 3. Expire all cookies for current path
      try {
        document.cookie.split(';').forEach((c) => {
          document.cookie = c
            .replace(/^ +/, '')
            .replace(
              /=.*/,
              '=;expires=' + new Date(0).toUTCString() + ';path=/'
            )
        })
      } catch (_) {
        /* no-op */
      }

      // 4. Clear browser caches
      if ('caches' in window) {
        try {
          const names = await caches.keys()
          await Promise.all(names.map((n) => caches.delete(n)))
        } catch (_) {
          /* no-op */
        }
      }

      // 5. Best-effort: clear any lingering MSAL cache without redirecting
      try {
        await instance?.clearCache?.()
      } catch (_) {
        /* no-op */
      }
    }

    cleanup()
  }, [dispatch, instance])

  const handleLoginAgain = () => {
    navigate('/login')
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#fff',
      }}
    >
      <Card
        style={{ 
          width: 500, 
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          borderRadius: '8px'
        }}
      >
        <Result
          icon={<LogoutOutlined style={{ color: '#52c41a' }} />}
          title="You have been logged out successfully"
          subTitle="All your session data and cache have been cleared. Thank you for using Application Tracker."
          extra={[
            <Space direction="vertical" size="middle" style={{ width: '100%' }} key="actions">
              <Button 
                type="primary" 
                size="large" 
                icon={<LoginOutlined />}
                onClick={handleLoginAgain}
                block
                style={{
                  height: '48px',
                  fontSize: '16px',
                  background: '#000',
                  borderColor: '#000',
                  color: '#fff',
                  fontWeight: 500,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = '#FFE600'
                  e.currentTarget.style.borderColor = '#FFE600'
                  e.currentTarget.style.color = '#000'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = '#000'
                  e.currentTarget.style.borderColor = '#000'
                  e.currentTarget.style.color = '#fff'
                }}
              >
                Sign In Again
              </Button>
              <Text type="secondary" style={{ fontSize: '12px', textAlign: 'center', display: 'block' }}>
                EY-IND-CBS-R-P-O-AppTracker-1.0-UAT
              </Text>
            </Space>
          ]}
        />
      </Card>
    </div>
  )
}

export default Logout
